import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { Trans, useTranslation } from "react-i18next";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import LoadingButton from "../../../components/LoadingButton";
import { useCheckout } from "../../providers/CheckoutProvider";

const VoucherCodeDialog = ({ handleClose }) => {
  const { t } = useTranslation();
  const [isChecking, setIsChecking] = useState(false);
  const [code, setCode] = useState("");
  const { setRebateCode } = useCheckout();
  const [error, setError] = useState();

  const handleChange = (e) => {
    setCode(e.target.value);
    setError(null);
  };
  const verifyVoucherCode = () => {
    setIsChecking(true);
    setRebateCode(code)
      .then(() => {
        handleClose();
      })
      .catch((err) => {
        setError(err);
        setIsChecking(false);
      });
  };

  return (
    <Dialog open={true} maxWidth="xs">
      <DialogTitle>
        <Trans>Add voucher code</Trans>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans>If you have a voucher code please enter it here.</Trans>
        </DialogContentText>
        <TextField
          margin="normal"
          id="code"
          label={t("Voucher code")}
          type="text"
          onChange={handleChange}
          fullWidth
          autoFocus
          error={!!error}
          helperText={error}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          <Trans>Cancel</Trans>
        </Button>
        <LoadingButton
          isLoading={isChecking}
          variant="primary"
          onClick={verifyVoucherCode}
        >
          <Trans>Add voucher code</Trans>
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default VoucherCodeDialog;
